import type { InferSelectModel } from 'drizzle-orm';
import * as schema from '../drizzle/schema';

export type CheckRunRecord = InferSelectModel<typeof schema.CheckRunsTable>;
export const QueuedCheckStatuses = ['QUEUED', 'WAITING', 'PENDING', 'REQUESTED'] as const;
export const FailureCheckConclusions = ['FAILURE', 'TIMED_OUT', 'CANCELLED', 'ACTION_REQUIRED', 'STALE'] as const;
